import React from 'react';
import { AppSection } from '../Conditions/Conditions';
import { Container } from 'react-bootstrap';
import { Franchise as FranchiseComponent } from '../../components';
import PhoneImg from '../../assets/images/phone.svg';
import styled from 'styled-components';

const Franchise = () => {
  return (
    <AppSection>
      <Container>
        <FranchiseComponent />
      </Container>
      <FranchiseBlockImage src={PhoneImg} alt="phone" />
    </AppSection>
  );
};

const FranchiseBlockImage = styled.img`
  position: absolute;
  top: 32px;
  right: 19.8%;
  @media (max-width: 1440px) {
    right: 11.4%;
  }
  @media (max-width: 1135px) {
    display: none;
  }
`;

export default Franchise;
